import { useStore } from '@stores';
import { useEffect } from 'react';

export const useConcernCategory = (id: string | undefined) => {
  const { concernStore } = useStore();
  const { concernCategory } = concernStore;

  useEffect(() => {
    id && concernStore.getConcernCategory({ id });

    return () => concernStore.clearConcernCategory();
  }, [concernStore, id]);

  return concernCategory;
};
